export const cdn = {
  modules_config:  'assets/toCDN/module_config.json',
};
